import { z } from 'zod';

import { HolidayRegion } from '../../types/team.types';

const dateStringSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Pick a valid date');

export const memberFormSchema = z.object({
  name: z.string().trim().min(1, 'Name is required').max(120, 'Name is too long'),
  role: z.string().trim().min(1, 'Role is required').max(120, 'Role is too long'),
  email: z.email('Enter a valid email'),
  startDate: dateStringSchema,
});

export type MemberFormValues = z.infer<typeof memberFormSchema>;

export const vacationFormSchema = z
  .object({
    teamMemberId: z.string().min(1, 'Select a team member'),
    startDate: dateStringSchema,
    endDate: dateStringSchema,
    notes: z.string().max(500, 'Notes are too long'),
  })
  .refine((data) => data.startDate <= data.endDate, {
    message: 'End date must be on or after the start date',
    path: ['endDate'],
  });

export type VacationFormValues = z.infer<typeof vacationFormSchema>;

export const holidayFormSchema = z.object({
  name: z.string().trim().min(1, 'Holiday name is required').max(120, 'Name is too long'),
  date: dateStringSchema,
  region: z.enum(HolidayRegion),
});

export type HolidayFormValues = z.infer<typeof holidayFormSchema>;

// Flatten a ZodError into a { field: firstMessage } map for inline form display.
export const getFieldErrors = (error: z.ZodError): Record<string, string> => {
  const fieldErrors: Record<string, string> = {};

  for (const issue of error.issues) {
    const key = issue.path[0];
    if (typeof key === 'string' && !fieldErrors[key]) {
      fieldErrors[key] = issue.message;
    }
  }

  return fieldErrors;
};
